import { motion } from 'framer-motion'
import ContactForm from '../components/ContactForm'
import CalendlyButton from '../components/CalendlyButton'
import GeofenceIcon from '../components/icons/GeofenceIcon'
import MailIcon from '../components/icons/MailIcon'
import TimeIcon from '../components/icons/TimeIcon'
import SEO from '../components/SEO'
import { generateOrganizationSchema } from '../lib/structured-data-utils'

const Contact = () => {
  const currentUrl = typeof window !== 'undefined' ? window.location.href : '';
  const organizationSchema = generateOrganizationSchema();

  return (
    <div className="pt-32 pb-16">
      <SEO
        title="Contact Demirix - IT Solutions in Dubai, UAE"
        description="Contact Demirix in Dubai, UAE for innovative IT solutions. Connect with our team for web development, cloud solutions, AI integration, and technology consulting services worldwide."
        keywords={['contact Demirix Dubai', 'IT solutions Dubai UAE', 'web development inquiry Dubai', 'technology consulting Dubai', 'get in touch Demirix', 'IT services Dubai', 'blockchain development Dubai', 'AI solutions Dubai', 'cloud services Dubai']}
        url={currentUrl}
        image="https://demirix.com/contact-hero.jpg"
        structuredData={organizationSchema}
      />
      <div className="container-custom">
        <motion.div
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
          className="text-center mb-16"
        >
          <h1 className="text-5xl md:text-6xl font-bold text-gray-900 dark:text-white mb-6">
            Let's Start Building
          </h1>
          <p className="text-xl text-gray-600 dark:text-gray-300 max-w-3xl mx-auto">
            Ready to transform your ideas into reality? Get in touch and let's discuss
            how we can help you achieve your technology goals. Not sure which service you need? View our <a href="/services" className="text-primary-600 dark:text-primary-400 hover:underline font-semibold">services</a> or learn more <a href="/about" className="text-primary-600 dark:text-primary-400 hover:underline font-semibold">about us</a>.
          </p>
        </motion.div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12">
          <motion.div
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.2 }}
          >
            <ContactForm />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.6, delay: 0.4 }}
            className="space-y-8"
          >
            <div>
              <h2 className="text-2xl font-bold text-gray-900 dark:text-white mb-6">Contact Information</h2>
              
              <div className="space-y-6">
                <div className="flex items-center">
                  <div className="w-14 h-14 bg-primary-100 dark:bg-primary-900/30 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <GeofenceIcon size={35} className="text-primary-600 dark:text-primary-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white">Location</h3>
                    <p className="text-gray-600 dark:text-gray-300">Dubai, United Arab Emirates</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">Serving clients globally</p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-14 h-14 bg-primary-100 dark:bg-primary-900/30 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <MailIcon size={35} className="text-primary-600 dark:text-primary-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white">Email</h3>
                    <p className="text-gray-600 dark:text-gray-300">hello@demirix.com</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">We'll respond within 24 hours</p>
                  </div>
                </div>

                <div className="flex items-center">
                  <div className="w-14 h-14 bg-primary-100 dark:bg-primary-900/30 rounded-lg flex items-center justify-center mr-4 flex-shrink-0">
                    <TimeIcon size={35} className="text-primary-600 dark:text-primary-400" />
                  </div>
                  <div>
                    <h3 className="font-semibold text-gray-900 dark:text-white">Response Time</h3>
                    <p className="text-gray-600 dark:text-gray-300">Within 24 hours</p>
                    <p className="text-sm text-gray-500 dark:text-gray-400">Usually much faster!</p>
                  </div>
                </div>
              </div>
            </div>

            <div className="bg-gray-50 dark:bg-gray-800 p-8 rounded-2xl">
              <h2 className="text-xl font-bold text-gray-900 dark:text-white mb-4">Prefer to Schedule Directly?</h2>
              <p className="text-gray-600 dark:text-gray-300 mb-6">
                Book a free 30-minute consultation call to discuss your project requirements and get a custom quote.
              </p>
              <div className="flex justify-center">
                <CalendlyButton 
                  variant="secondary"
                  className="w-full md:w-auto"
                >
                  Schedule Free Consultation
                </CalendlyButton>
              </div>
            </div>

            <div className="bg-primary-600 dark:bg-primary-700 text-white p-8 rounded-2xl">
              <h2 className="text-xl font-bold mb-4">Quick Response Guarantee</h2>
              <p className="opacity-90">
                We understand that time is crucial for your business. That's why we guarantee a response 
                to all inquiries within 24 hours, often much sooner.
              </p>
            </div>
          </motion.div>
        </div>
      </div>
    </div>
  )
}

export default Contact